// todo Need to map this as soon as we know what the new service returns.
export var LegacyBankInfoAdaptor = function(bankInfoData) {
    var bankInfo = {};
    
    // Constructor
    if (bankInfoData) {
        bankInfo.accountName = '';
        bankInfo.accountType = '';
        bankInfo.accountNumber = '';
        bankInfo.routingNumber = '';
        bankInfo.directDepositPolicy = '';
        bankInfo.country = '';
        bankInfo.IBAN = '';
        bankInfo.branchName = '';
        bankInfo.validFromDate = '';
        bankInfo.validToDate = '';
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return bankInfo;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/adaptors/legacyBankInfoAdaptor.js
// module id = 202
// module chunks = 0